export const privacyPolicyBodyNl = `Laatst bijgewerkt: 3 oktober 2026

Deze kennisgeving beschrijft hoe persoonsgegevens worden verwerkt van gebruikers die het onlineportaal van pro20.net gebruiken om reserveringen te maken, bestellingen te plaatsen, informatie op te vragen en gebruik te maken van de andere aangeboden diensten.

## 1. Verwerkingsverantwoordelijke

De verwerkingsverantwoordelijke voor de persoonsgegevens is:

Mada Srl

Handelsnaam: Mada Srl

Vestiging: Via 4 novembre 12 - Cisternino (BR) 72014

Btw- / fiscaal nummer: 02750160745

E-mail: {{email}}

PEC: -

Voor elk verzoek over de bescherming van persoonsgegevens kunt u contact opnemen met de verwerkingsverantwoordelijke via de bovenstaande gegevens.

Als een functionaris voor gegevensbescherming (FG) is aangesteld, kunt u deze bereiken op:

{{email}}

## 2. Soorten verwerkte gegevens

Bij het gebruik van het portaal kunnen, afhankelijk van de gebruikte diensten, de volgende gegevens worden verzameld en verwerkt:

- voor- en achternaam;
- e-mailadres;
- telefoonnummer en landcode;
- informatie over reserveringen;
- aantal personen bij de reservering;
- datum en tijd van de reservering;
- informatie en verzoeken die de gebruiker vrijwillig invult;
- geschiedenis van reserveringen en bezoeken;
- informatie over geplaatste bestellingen;
- gekochte producten en diensten;
- informatie over levering of afhalen van bestellingen;
- informatie over transacties en de betalingsstatus;
- eventuele promotiecodes, coupons, punten of loyaliteitsprogramma's;
- voorkeuren en toestemmingen van de gebruiker;
- technische gegevens die nodig zijn voor de werking en beveiliging van het portaal.

Plaats geen onnodige informatie in notities of vrije verzoeken, in het bijzonder persoonsgegevens van bijzondere categorieën in de zin van artikel 9 AVG, tenzij dat strikt nodig is om het verzoek te behandelen.

## 3. Doeleinden en rechtsgrondslagen van de verwerking

### 3.1 Reserveringen

Persoonsgegevens worden verwerkt om:

- een reserveringsverzoek te ontvangen en te beheren;
- een reservering te bevestigen, te wijzigen of te annuleren;
- contact op te nemen met de klant over de reservering;
- aankomst en aanwezigheid in het restaurant te beheren;
- eventuele verzoeken die aan de reservering zijn gekoppeld te beheren.

De rechtsgrondslag is de uitvoering van een overeenkomst of van precontractuele maatregelen op verzoek van de betrokkene op grond van artikel 6, lid 1, onder b, AVG.

## 4. Bestellingen, afhalen en bezorging

Wanneer het portaal bestellingen mogelijk maakt, kunnen persoonsgegevens worden gebruikt om:

- de bestelling te ontvangen en te beheren;
- de bestelde producten te bereiden;
- afhalen in het restaurant te beheren;
- eventuele bezorging te organiseren;
- updates over de status van de bestelling te sturen;
- wijzigingen, annuleringen of terugbetalingen te beheren;
- klantenservice te verlenen.

De rechtsgrondslag is de uitvoering van de overeenkomst of van precontractuele maatregelen op verzoek van de betrokkene.

## 5. Betalingen

Waar voorzien, kan het portaal betaling van bestellingen, aanbetalingen, voorschotten, diensten of andere bedragen mogelijk maken via gespecialiseerde aanbieders van betalingsdiensten.

De gegevens die voor de transactie nodig zijn, kunnen rechtstreeks aan de betalingsdienstverlener worden doorgegeven.

Het restaurant en het portaal kunnen informatie ontvangen over het resultaat van de transactie, zoals:

- betaling uitgevoerd;
- betaling geweigerd;
- kaartautorisatie;
- aanbetaling gedaan;
- terugbetaling;
- transactie-id.

De volledige gegevens van de betaalkaart worden niet door het restaurant opgeslagen wanneer de betaling rechtstreeks door de betalingsprovider wordt afgehandeld.

De rechtsgrondslag is de uitvoering van de overeenkomst en, waar van toepassing, het nakomen van een wettelijke verplichting.

## 6. Berichten over de dienst

De contactgegevens die de gebruiker verstrekt, kunnen worden gebruikt om berichten te sturen die strikt verband houden met de gevraagde dienst, bijvoorbeeld:

- bevestiging van de reservering;
- verzoek om bevestiging;
- wijziging of annulering van de reservering;
- herinnering van de reservering;
- bevestiging van de bestelling;
- update over de status van de bestelling;
- berichten over de betaling;
- informatie die nodig is voor een correcte uitvoering van de dienst.

Deze berichten kunnen, afhankelijk van de verstrekte contactgegevens en de door het restaurant geactiveerde diensten, worden verstuurd via e-mail, sms, WhatsApp of andere berichtensystemen.

Wanneer ze strikt nodig zijn voor het beheer van de gevraagde dienst, zijn deze berichten geen promotieberichten.

## 7. Marketing en promotieberichten

Alleen met toestemming van de gebruiker mogen contactgegevens worden gebruikt voor commerciële en promotionele berichten over:

- aanbiedingen en acties;
- evenementen;
- nieuwe menu's of producten;
- initiatieven van het restaurant;
- coupons en kortingscodes;
- loyaliteitsprogramma's;
- gepersonaliseerde commerciële berichten.

Berichten kunnen worden verstuurd via de kanalen waarvoor de gebruiker toestemming heeft gegeven, zoals e-mail, sms, WhatsApp of andere middelen die de toepasselijke wet toestaat.

Toestemming voor marketingdoeleinden is optioneel.

Het weigeren van toestemming verhindert niet om te reserveren, te bestellen of de andere hoofddiensten van het portaal te gebruiken.

Toestemming kan op elk moment worden ingetrokken, zonder afbreuk te doen aan de rechtmatigheid van verwerkingen vóór de intrekking.

## 8. Profilering en personalisatie

Alleen waar dit is voorzien en met toestemming wanneer de wet dat vereist, mag de verwerkingsverantwoordelijke informatie over de interacties van de gebruiker met het restaurant gebruiken om interesses, gewoonten en voorkeuren te analyseren.

Bij wijze van voorbeeld kan het gaan om:

- frequentie van reserveringen;
- bestelgeschiedenis;
- gekochte producten;
- gebruik van acties en coupons;
- deelname aan loyaliteitsprogramma's;
- voorkeuren die de gebruiker heeft aangegeven;
- interacties met promotieberichten.

Deze informatie kan worden gebruikt om klantsegmenten te maken en aanbiedingen, acties en berichten relevanter te maken.

Toestemming voor profilering is, wanneer die vereist is, optioneel en kan op elk moment worden ingetrokken.

Het weigeren van toestemming verhindert het gebruik van de gewone reserverings- en besteldiensten niet.

## 9. Loyaliteitsprogramma's, acties en coupons

Wanneer het restaurant loyaliteitsprogramma's, acties, spaarpunten of coupons aanbiedt, kunnen de gegevens van de gebruiker worden verwerkt om:

- punten of voordelen toe te kennen;
- de voorwaarden voor een actie te controleren;
- coupons te genereren;
- het gebruik van coupons te controleren;
- beloningen en voordelen te beheren;
- frauduleus gebruik van acties te voorkomen.

De specifieke voorwaarden van het programma of de actie kunnen in een afzonderlijk reglement staan.

## 10. Automatiseringen

Het restaurant kan automatische systemen gebruiken om sommige activiteiten in de klantrelatie te beheren.

Het systeem kan bijvoorbeeld automatisch:

- een herinnering sturen vóór een reservering;
- een bericht sturen na een bezoek;
- de status van een reservering of bestelling bijwerken;
- punten of coupons toekennen;
- berichten sturen wanneer bepaalde voorwaarden zich voordoen.

Wanneer deze automatiseringen een promotioneel doel hebben of profilering inhouden, gelden de bijbehorende rechtsgrondslagen en wordt, waar nodig, vooraf toestemming van de gebruiker gevraagd.

## 11. Verstrekking van gegevens

Het verstrekken van gegevens die als verplicht zijn gemarkeerd, is nodig om de gevraagde dienst te kunnen leveren.

Als bijvoorbeeld de gegevens die voor een reservering nodig zijn ontbreken, kan het onmogelijk zijn de reservering te voltooien.

Het verstrekken van gegevens en toestemming voor marketing en profilering is optioneel en heeft geen invloed op de toegang tot de hoofddiensten.

## 12. Ontvangers van de gegevens

Persoonsgegevens kunnen worden verwerkt door personeel dat door de verwerkingsverantwoordelijke is gemachtigd en door leveranciers die diensten leveren die nodig zijn voor de bedrijfsvoering en het platform.

Bij wijze van voorbeeld kunnen dit zijn:

- leveranciers van het softwareplatform;
- hosting- en cloudproviders;
- aanbieders van e-maildiensten;
- aanbieders van sms-diensten;
- aanbieders van berichtendiensten;
- aanbieders van betalingsdiensten;
- aanbieders van bezorgdiensten;
- technische, administratieve of fiscale adviseurs;
- andere partijen die gegevens verwerken namens de verwerkingsverantwoordelijke.

Waar de wet dat voorschrijft, treden deze partijen op als verwerkers in de zin van artikel 28 AVG.

Gegevens kunnen ook aan de bevoegde autoriteiten worden verstrekt wanneer een wettelijke verplichting dat vereist.

## 13. Doorgifte van gegevens buiten de Europese Economische Ruimte

Sommige technologieleveranciers die de verwerkingsverantwoordelijke gebruikt, kunnen persoonsgegevens buiten de Europese Economische Ruimte verwerken.

In die gevallen vinden de verwerking en de doorgifte plaats met inachtneming van de AVG, met de toepasselijke instrumenten en waarborgen, zoals adequaatheidsbesluiten of standaardcontractbepalingen die door de Europese Commissie zijn goedgekeurd, waar nodig.

## 14. Bewaartermijn

Persoonsgegevens worden bewaard zolang dat nodig is voor de doelen waarvoor ze zijn verzameld en daarna gedurende eventuele termijnen die de toepasselijke wet vereist.

In het bijzonder:

- gegevens over reserveringen en bestellingen worden bewaard gedurende de periode die nodig is voor het beheer van de klantrelatie en eventuele administratieve, boekhoudkundige of wettelijke verplichtingen;
- gegevens over transacties worden bewaard volgens de toepasselijke fiscale en boekhoudkundige verplichtingen;
- gegevens die voor marketing worden gebruikt, worden bewaard tot de toestemming wordt ingetrokken of gedurende een andere termijn die de verwerkingsverantwoordelijke vaststelt volgens de beginselen van noodzaak en evenredigheid;
- gegevens die voor profilering worden gebruikt, worden bewaard gedurende de termijn die de verwerkingsverantwoordelijke vaststelt in verband met de nagestreefde doelen en worden daarna gewist of geanonimiseerd.

De concrete bewaartermijnen van de verwerkingsverantwoordelijke kunnen worden opgevraagd via de contactgegevens in deze kennisgeving.

## 15. Beveiliging van gegevens

De verwerkingsverantwoordelijke en de betrokken leveranciers nemen technische en organisatorische maatregelen die passen bij het risico om persoonsgegevens te beschermen tegen verlies, vernietiging, onbevoegde toegang, openbaarmaking, wijziging of onrechtmatige verwerking.

## 16. Rechten van de betrokkene

In de gevallen die de AVG voorziet, kan de betrokkene zijn of haar rechten uitoefenen en in het bijzonder verzoeken om:

- inzage in de eigen persoonsgegevens;
- rectificatie van onjuiste gegevens;
- wissing van gegevens;
- beperking van de verwerking;
- overdraagbaarheid van gegevens;
- bezwaar tegen de verwerking;
- intrekking van eerder gegeven toestemming.

Intrekking van toestemming doet geen afbreuk aan de rechtmatigheid van de verwerking vóór de intrekking.

Verzoeken kunnen worden gestuurd naar:

{{email}}

De betrokkene heeft ook het recht een klacht in te dienen bij de Italiaanse toezichthoudende autoriteit (Garante per la protezione dei dati personali) op de wijze die de geldende wet voorschrijft.

## 17. Cookies en vergelijkbare technologieën

Het portaal kan cookies en andere technologieën gebruiken die nodig zijn voor de werking.

Eventueel gebruik van analytische cookies, profileringscookies of cookies van derden wordt geregeld door het specifieke cookiebeleid op het portaal en, waar nodig, via het systeem voor toestemmingsbeheer.

## 18. Wijzigingen van deze kennisgeving

De verwerkingsverantwoordelijke kan deze kennisgeving periodiek bijwerken om deze aan te passen aan wijzigingen in de wet, de techniek of de aangeboden diensten.

De bijgewerkte versie wordt via het portaal beschikbaar gesteld.

Laatst bijgewerkt: 03 oktober 2026`;
